import request from '@/utils/request'
// 身体部位列表
export function bodyList(params) {
  return request({
    url: '/sms/smsBodyPartsInfo/api/n/list',
    method: 'get',
    params
  })
}
// 身体部位病症列表
export function partSymptomList(params) {
  return request({
    url: '/sms/smsBodyPartsInfo/api/n/listBodyPartsSymptomByPartsId',
    method: 'get',
    params
  })
}
// 搜索症状
export function searchSymptom(params) {
  return request({
    url: '/sms/smsBodyPartsInfo/api/n/listBodyPartsSymptomByParam',
    method: 'GET',
    params
  })
}
// 获取疾病信息
export function diseaseInfo(params) {
  return request({
    url: '/sms/smsBodyPartsInfo/api/n/getOneInfoByDiseaseId',
    method: 'GET',
    params
  })
}